import React from 'react';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
// import paths from 'routes/paths';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import SubtleBadge from 'components/common/SubtleBadge';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import paths from 'routes/paths';
import moment from 'moment';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Avatar from 'components/common/Avatar';
import Flex from 'components/common/Flex';
import { FaSort } from 'react-icons/fa6';

const JobTable = ({
  data,
  orderBy,
  setOrderBy,
  orderByValue,
  setOrderByValue
}) => {
  const columns = [
    {
      accessorKey: 'id',
      header: () => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'row',
            cursor: 'pointer'
          }}
          onClick={() => {
            setOrderBy('id');
            setOrderByValue(
              orderByValue === 'asc'
                ? 'desc'
                : orderByValue === 'desc'
                ? 'asc'
                : ''
            );
          }}
        >
          <h6 className="mt-2">Job Id</h6>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              marginLeft: 2
            }}
          >
            <FaSort color={orderBy === 'id' ? '#888' : '#ccc'} />
          </div>
        </div>
      ),
      enableSorting: false,
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { id } = original;
        return (
          <OverlayTrigger
            placement={'left'}
            overlay={
              <Tooltip
                style={{ position: 'fixed' }}
                id="overlay-trigger-example"
              >
                Job Id - {id}
              </Tooltip>
            }
          >
            <Link to={paths.nursd_schedule_details(id)}>
              <h5 className="mb-0 fs-10 text-primary">{id}</h5>
            </Link>
          </OverlayTrigger>
        );
      }
    },
    {
      accessorKey: 'title',
      header: () => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'row',
            cursor: 'pointer'
          }}
          onClick={() => {
            setOrderBy('shiftTitle');
            setOrderByValue(
              orderByValue === 'asc'
                ? 'desc'
                : orderByValue === 'desc'
                ? 'asc'
                : ''
            );
          }}
        >
          <h6 className="mt-2">Title</h6>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              marginLeft: 2
            }}
          >
            <FaSort color={orderBy === 'shiftTitle' ? '#888' : '#ccc'} />
          </div>
        </div>
      ),
      enableSorting: false,
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { title } = original;
        return <h5 className="mb-0 fs-10">{title}</h5>;
      }
    },
    {
      accessorKey: 'start',
      header: () => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'row',
            cursor: 'pointer'
          }}
          onClick={() => {
            setOrderBy('startDate');
            setOrderByValue(
              orderByValue === 'asc'
                ? 'desc'
                : orderByValue === 'desc'
                ? 'asc'
                : ''
            );
          }}
        >
          <h6 className="mt-2">Start</h6>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              marginLeft: 2
            }}
          >
            <FaSort color={orderBy === 'startDate' ? '#888' : '#ccc'} />
          </div>
        </div>
      ),
      enableSorting: false,
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { start } = original;
        return (
          <h5 className="mb-0 fs-10">
            {moment(start).format('MMMM DD YYYY hh:mm a')}
          </h5>
        );
      }
    },
    // {
    //   accessorKey: 'end',
    //   header: 'End',
    //   meta: {
    //     headerProps: { className: 'text-900' }
    //   },
    //   cell: ({ row: { original } }) => {
    //     const { end } = original;
    //     return (
    //       <h5 className="mb-0 fs-10">
    //         {moment(end).format('MMMM DD YYYY hh:mm a')}
    //       </h5>
    //     );
    //   }
    // },
    {
      accessorKey: 'jobType',
      header: () => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'row',
            cursor: 'pointer'
          }}
          onClick={() => {
            setOrderBy('jobType');
            setOrderByValue(
              orderByValue === 'asc'
                ? 'desc'
                : orderByValue === 'desc'
                ? 'asc'
                : ''
            );
          }}
        >
          <h6 className="mt-2">Type</h6>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              marginLeft: 2
            }}
          >
            <FaSort color={orderBy === 'jobType' ? '#888' : '#ccc'} />
          </div>
        </div>
      ),
      enableSorting: false,
      meta: {
        headerProps: { className: 'text-900' },
        cellProps: { className: '' }
      },
      cell: ({ row: { original } }) => {
        return <h5 className="mb-0 fs-10">{original?.original?.jobType}</h5>;
      }
    },
    {
      accessorKey: 'status',
      header: () => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'row',
            cursor: 'pointer'
          }}
          onClick={() => {
            setOrderBy('jobStatus');
            setOrderByValue(
              orderByValue === 'asc'
                ? 'desc'
                : orderByValue === 'desc'
                ? 'asc'
                : ''
            );
          }}
        >
          <h6 className="mt-2">Status</h6>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              marginLeft: 2
            }}
          >
            <FaSort color={orderBy === 'jobStatus' ? '#888' : '#ccc'} />
          </div>
        </div>
      ),
      enableSorting: false,
      meta: {
        headerProps: { className: 'text-900' },
        cellProps: { className: '' }
      },
      cell: ({ row: { original } }) => {
        const { status } = original;
        return (
          <SubtleBadge
            pill
            bg={
              status === 'Missed' || status === 'Pending Clock Out'
                ? 'danger'
                : status === 'Nurse Assigned' || status === 'In-Progress'
                ? 'success'
                : status === 'Unfulfilled'
                ? 'secondary'
                : 'primary'
            }
          >
            {status}
          </SubtleBadge>
        );
      }
    },
    {
      accessorKey: 'customer',
      header: 'Customer',
      enableSorting: false,
      meta: {
        headerProps: { className: 'pe-1 text-900' },
        cellProps: {
          className: 'py-2'
        }
      },
      cell: ({ row: { original } }) => {
        const { customer } = original;
        return (
          <>
            {customer ? (
              <Link to={paths.customer_profile(customer?.id, 'profile')}>
                <div className="flex-1">
                  <h5 className="mb-0 fs-10  text-primary">{customer?.name}</h5>
                </div>
              </Link>
            ) : (
              <h5 className="mb-0 fs-10">-</h5>
            )}
          </>
        );
      }
    },
    {
      accessorKey: 'nurse',
      header: 'Assigned',
      enableSorting: false,
      meta: {
        headerProps: { className: 'pe-1 text-900' },
        cellProps: {
          className: 'py-2'
        }
      },
      cell: ({ row: { original } }) => {
        const { nurse } = original;
        return (
          <>
            {nurse ? (
              <Link to={paths.nursd_profile(nurse?.id, 'profile')}>
                <Flex alignItems="center">
                  {nurse?.profileImage ? (
                    <Avatar
                      src={nurse?.profileImage}
                      size="xl"
                      className="me-2"
                    />
                  ) : (
                    <Avatar size="xl" name={nurse?.name} className="me-2" />
                  )}
                  <div className="flex-1">
                    <h5 className="mb-0 fs-10 text-primary">{nurse?.name}</h5>
                    <h5 className="mb-0 fs-10">{nurse?.licenseType}</h5>
                  </div>
                </Flex>
              </Link>
            ) : (
              <h5 className="mb-0 fs-10">-</h5>
            )}
          </>
        );
      }
    },
    {
      accessorKey: 'manager',
      header: 'Manager',
      enableSorting: false,
      meta: {
        headerProps: { className: 'pe-1 text-900' },
        cellProps: {
          className: 'py-2'
        }
      },
      cell: ({ row: { original } }) => {
        const { manager } = original;
        return (
          <>
            {manager ? (
              <Link to={paths.nursd_manager}>
                <Flex alignItems="center">
                  {manager?.profileImage ? (
                    <Avatar
                      src={manager?.profileImage}
                      size="xl"
                      className="me-2"
                    />
                  ) : (
                    <Avatar size="xl" name={manager?.name} className="me-2" />
                  )}
                  <div className="flex-1">
                    <h5 className="mb-0 fs-10 text-primary">{manager?.name}</h5>
                  </div>
                </Flex>
              </Link>
            ) : (
              <h5 className="mb-0 fs-10">-</h5>
            )}
          </>
        );
      }
    },
    {
      accessorKey: 'createdAt',
      header: () => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'row',
            cursor: 'pointer'
          }}
          onClick={() => {
            setOrderBy('createdAt');
            setOrderByValue(
              orderByValue === 'asc'
                ? 'desc'
                : orderByValue === 'desc'
                ? 'asc'
                : ''
            );
          }}
        >
          <h6 className="mt-2">Created</h6>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              marginLeft: 2
            }}
          >
            <FaSort color={orderBy === 'createdAt' ? '#888' : '#ccc'} />
          </div>
        </div>
      ),
      enableSorting: false,
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { createdAt } = original;
        return (
          <h5 className="mb-0 fs-10">
            {moment(createdAt).format('MMMM DD YYYY hh:mm a')}
          </h5>
        );
      }
    }
  ];

  const table = useAdvanceTable({
    data: data,
    columns,
    selection: false,
    sortable: true,
    pagination: false,
    perPage: 20
  });

  return (
    <>
      <AdvanceTableProvider {...table}>
        <AdvanceTable
          headerClassName="bg-200 text-nowrap align-middle"
          rowClassName="align-middle white-space-nowrap"
          tableProps={{
            size: 'sm',
            striped: true,
            className: 'fs-10 mb-0 overflow-hidden'
          }}
        />
      </AdvanceTableProvider>
    </>
  );
};

JobTable.propTypes = {
  data: PropTypes.any,
  orderBy: PropTypes.any,
  setOrderBy: PropTypes.any,
  orderByValue: PropTypes.any,
  setOrderByValue: PropTypes.any
};

export default JobTable;
